// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import UserPropertiesConstants from 'constants/UserPropertiesConstants'

const UserPropertiesStore = Marty.createStore({
  id: 'UserPropertiesStore',

  getInitialState() {
    return {
      settingsByUserId: {},
      userPropertiesUpdateState: {}
    }
  },

  handlers: {
    fetchSettingsDone: UserPropertiesConstants.FETCH_USER_PROPERTIES_DONE,
    updateSettingsDone: UserPropertiesConstants.UPDATE_USER_PROPERTIES_DONE
  },

  updateUserProperties(userId, settings) {
    this.app.actions.UserPropertiesActions.updateProperties(userId, settings)
    const userPropertiesUpdateState = _.cloneDeep(this.state.userPropertiesUpdateState)
    userPropertiesUpdateState[userId] = UserPropertiesConstants.UPDATE_USER_PROPERTIES_STARTING
    return this.setState({ userPropertiesUpdateState })
  },

  setSettingForUserId(userId, settings) {
    const settingsByUserId = _.cloneDeep(this.state.settingsByUserId)
    settingsByUserId[userId] = settings
    return this.setState({ settingsByUserId })
  },

  fetchSettingsDone(userId, settings) {
    return this.setSettingForUserId(userId, settings)
  },

  updateSettingsDone(userId, settings) {
    this.setSettingForUserId(userId, settings)
    const userPropertiesUpdateState = _.cloneDeep(this.state.userPropertiesUpdateState)
    userPropertiesUpdateState[userId] = UserPropertiesConstants.UPDATE_USER_PROPERTIES_DONE
    return this.setState({ userPropertiesUpdateState })
  },

  getUserPropertiesUpdateState() {
    return this.state.userPropertiesUpdateState
  },

  defaultUserProperties: {
    'humane-notifications-browser' : 'mine',
    'humane-notifications-browser-with-sound' : true,
    'humane-notifications-push' : 'mine',
    'humane-notifications-push-with-sound' : true,
    'humane-notifications-email' : 'mine'
  },

  fetchPropertiesForUser(userId) {
    return this.fetch({
      id: `fetchPropertiesForUser${ userId }`,
      locally() {
        const properties = this.state.settingsByUserId[userId]

        if (!properties) {
          return
        }

        return _.defaults(properties, this.defaultUserProperties)
      },
      remotely() {
        return this.app.queries.UserPropertiesQueries.fetchProperties(userId)
      }
    })
  },

  fetchPropertiesForCurrentUser() {
    return this.fetch({
      id: 'fetchPropertiesForCurrentUser',
      dependsOn: this.app.stores.UserStore.getOrFetchCurrentUser(),
      locally() {
        const properties = this.state.settingsByUserId[this.app.stores.UserStore.getCurrentUser().id]

        if (!properties) {
          return
        }

        return _.defaults(properties, this.defaultUserProperties)
      },

      remotely() {
        return this.app.queries.UserPropertiesQueries.fetchProperties(this.app.stores.UserStore.getCurrentUser().id)
      }
    })
  }
})

export default UserPropertiesStore



// WEBPACK FOOTER //
// ./src/scripts/stores/UserPropertiesStore.js